<template>
    <div class="setting-component">

        <!-- [ Menu ] end -->
        <div class="wrap">
            <div class="wrap__tree">
                <div class="nav-tree">
                    <el-button @click="openModalAdd('create')" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('general_add')}} {{btnText}}</el-button>
                </div>
                <el-table
                        max-height="650"
                        ref="singleTable"
                        highlight-current-row
                        :empty-text="$t('general_noData')"
                        @current-change="handleCurrentChange"
                        :data="tableData"
                        style="width: 100%"
                        row-key="id"
                        default-expand-all>
                    <el-table-column
                            prop="groupId"
                            :label="$t('settings_accountThink_GLAccountGroups_groupId')">
                    </el-table-column>
                    <el-table-column
                            prop="name"
                            :label="$t('settings_accountThink_GLAccountGroups_groupName')">
                    </el-table-column>
                    <!--<el-table-column-->
                            <!--prop="subGroupName"-->
                            <!--label="Subgroup of">-->
                    <!--</el-table-column>-->
                    <el-table-column
                            :label="$t('settings_accountThink_GLAccountGroups_class')">
                        <template slot-scope="scope">
                              <div>{{scope.row.class.class.className}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            width="150"
                            :label="$t('settings_accountThink_GLAccountGroups_operations')">
                        <template slot-scope="scope">
                            <el-button
                                    size="mini"
                                    type="primary"
                                    plain
                                    icon="el-icon-edit"
                                    @click="openModalAdd('update', scope.$index, scope.row)"></el-button>
                            <el-button
                                    size="mini"
                                    type="danger"
                                    plain
                                    icon="el-icon-delete"
                                    @click="handleDelete(scope.$index, scope.row)"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- Add -->
        <sweet-modal blocking :title="`${$t('general_add')} ${btnText}`" ref="openModal" class="modal" v-on:close="closeModal">
            <el-form :model="form" ref="form" status-icon :rules="rules" label-width="0" class="demo-ruleForm">
                <el-form-item prop="groupId">
                    <el-input type="number" :label="$t('settings_accountThink_GLAccountGroups_groupId')" v-model="form.groupId"></el-input>
                </el-form-item>
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_GLAccountGroups_groupName')" v-model="form.name"></el-input>
                </el-form-item>
                <!--<el-form-item>-->
                    <!--<el-select v-model="form.subGroupId" placeholder="Subgroup of" style="width: 100%;">-->
                        <!--<el-option v-for="item in subGroupList"-->
                                   <!--:key="item.id"-->
                                   <!--:label="item.name"-->
                                   <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item>
                    <el-select v-model="form.classId" :placeholder="$t('settings_accountThink_GLAccountGroups_class')" style="width: 100%;">
                        <el-option v-for="item in classList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModal')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="addItem('form')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>

        <!-- Edit -->
        <sweet-modal blocking :title="`${$t('general_edit')} ${btnText}`" ref="openModalEdit" class="modal" v-on:close="closeModalEdit">
            <el-form :model="formEdit" ref="formEdit" status-icon :rules="rulesEdit" label-width="0" class="demo-ruleForm">
                <el-form-item  prop="groupId">
                    <el-input type="number" :label="$t('settings_accountThink_GLAccountGroups_groupId')" v-model="formEdit.groupId"></el-input>
                </el-form-item>
                <el-form-item prop="name">
                    <el-input :label="$t('settings_accountThink_GLAccountGroups_groupName')" v-model="formEdit.name"></el-input>
                </el-form-item>
                <!--<el-form-item>-->
                    <!--<el-select v-model="formEdit.subGroupId" placeholder="Subgroup of" style="width: 100%;">-->
                        <!--<el-option v-for="item in subGroupList"-->
                                   <!--:key="item.id"-->
                                   <!--:label="item.name"-->
                                   <!--:value="item.id">-->
                        <!--</el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
                <el-form-item>
                    <el-select v-model="formEdit.classId" :placeholder="$t('settings_accountThink_GLAccountGroups_class')" style="width: 100%;">
                        <el-option v-for="item in classList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="modal__btn">
                  <el-button @click="modalCancel('openModalEdit')">{{$t('general_cancel')}}</el-button>
                  <el-button @click="editItem('formEdit')" type="primary">{{$t('general_submit')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>


    </div>
</template>

<script>
  import _ from 'lodash'
  // import Header from '@/components/Header.vue'
  // import Menu from '@/components/Menu.vue'

  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

  export default {
    name: 'settingGLAccountGroups',
    components: {
      // Header,
      // Menu,
      SweetModal,

    },
    data() {
      return {
        btnText: this.$i18n.t('settings_accountThink_GLAccountGroups_GLAccountGroup'),
        tableData: [],
        selectedRowId: '',
        moment:moment,
        // classTypeList: [],
        classList: [],
        subGroupList: [],
        form:{
          groupId: '',
          name: '',
          // subGroupId: '',
          classId: '',
        },
        formEdit:{
          groupId: '',
          name: '',
          // subGroupId: '',
          classId: '',
        },
        rules: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          // groupId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          // ],
          classId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        rulesEdit: {
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
          // groupId: [
          //   { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          // ],
          classId: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ]
        },
        modalDel:false,
        currentRow: null,
      }
    },
    methods: {
      modalCancel(ref) {
        this.$refs[ref].close();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        console.log('---handleCurrentChange', val);
      },
      loadList(){
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccountGroups/list?companyId=${this.$route.query.companyId}`)
          .then(response => {

            // this.tableData = list
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      openModalAdd(operation, index, row){
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccountGroups/directories?companyId=${this.$route.query.companyId}`)
          .then(response => {
            if(operation === 'create'){
              this.classList = response.data.directory
              this.$refs.openModal.open()
            }else if(operation === 'update'){
              this.classList = response.data.directory
              this.handleEdit(index, row)
            }
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      // * companyChartOfAccountItems/create
      addItem(form){
        this.$refs[form].validate((valid) => {
          if (valid) {
            let data = {
              classId: this.form.classId,
              inactive: 0,
              name: this.form.name,
              groupId: this.form.groupId
            }

            const ifCheck = this.checkCode(this.tableData, this.form.groupId)
            if (ifCheck){
              return this.openAlert('Unique Group ID required', 'Attention')
            }

            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/glAccountGroups/create?companyId=${this.$route.query.companyId}`, data)
              .then(response => {
                this.notification("Success", `Add ${this.btnText}`, "success");
                this.$refs.openModal.close()
                this.loadList()
              })
              .catch(error => {
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      checkCode(data, code){
        console.log('data', data)
        for (let i = 0; i < data.length; i++){
          if(data[i].groupId == Number(code)){
            return true
          }
        }
        return false
      },
      openAlert(message, title) {
        this.$alert(message, title, {
          confirmButtonText: 'OK',
          callback: action => {

          }
        });
      },
      closeModal(){
        this.form.name = ''
        this.form.groupId = ''
        this.form.classId = ''
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.formEdit.name = ''
        this.form.groupId = ''
        this.form.classId = ''
        this.$refs['formEdit'].resetFields();
      },
      // * companyChartOfAccountItems/item
      handleEdit(index, row) {
        this.selectedRowId = row.id
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/glAccountGroups/item?companyId=${this.$route.query.companyId}&id=${row.id}`)
          .then(response => {
            this.$refs.openModalEdit.open()
            this.formEdit.name = response.data.item.name
            this.formEdit.groupId = response.data.item.groupId
            this.formEdit.classId = response.data.item.classId
            // this.formEdit.subGroupId = response.data.item.subGroupId
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
      },
      // * companyChartOfAccountItems/update
      editItem(formEdit){
        this.$refs[formEdit].validate((valid) => {
          if (valid) {
            let data = {
              classId: this.formEdit.classId,
              name: this.formEdit.name,
              inactive: 0,
              groupId: this.formEdit.groupId
              // subGroupId: this.formEdit.subGroupId
            }
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/glAccountGroups/update?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`, data)
              .then(response => {
                this.notification("Success", `Edit ${this.btnText}`, "success");
                this.$refs.openModalEdit.close()
                this.loadList()
                loader.hide()
              })
              .catch(error => {
                loader.hide()
                console.log('An error occurred:', error);
              });
          }else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      handleDelete(index, row) {
        console.log(row.id)
        // this.$refs.confirmation.open()
        this.selectedRowId = row.id
        console.log(row)

        this.$confirm('This will permanently delete the group. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/glAccountGroups/delete?companyId=${this.$route.query.companyId}&id=${this.selectedRowId}`)
            .then(response => {
              // this.$refs.confirmation.close()
              this.loadList()
              this.notification("Success", `Delete ${this.btnText}`, "success");
            })
            .catch(error => {
              console.log('An error occurred:', error);
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      // * companyChartOfAccountItems/delete
      // deleteConfirm(){
      //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      //   axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      //   axios
      //     .post(`/api/v1/companyChartOfAccountItems/delete?companyId=${this.$route.query.companyId}&companyChartOfAccountItemId=${this.selectedRowId}`)
      //     .then(response => {
      //       this.$refs.confirmation.close()
      //       this.loadList()
      //       this.notification("Success", `Delete ${this.btnText}`, "success");
      //     })
      //     .catch(error => {
      //       console.log('An error occurred:', error);
      //     });
      // },
      // showMenu() {
      //   this.open = true
      //   console.log('---', this.open);
      // },
      // hideMenu() {
      //   this.open = false
      //   console.log('---', this.open);
      // },
      // companyName(name) {
      //   this.companyNameSelect = name
      // },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
    .setting-component{
        min-width:810px;
    }
    .sweet-modal-overlay{
        z-index:10;
    }
    /deep/.el-notification .right{
        z-index: 9999999;
    }
</style>
